<template>
    <modal class="zpCouponspayModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">正品卡券核销<span class="close" @click="hide()">×</span></div>
        <div ref="code">
        <div class="The-head">
            请输入或扫码：
            <div class="from-input" >
                <i v-if="$webBrowser?.isMobile?.Android" class="iconfont icon-a-saoma13x" @click="scanCode"></i>
                <i v-else class="iconfont icon-a-saoma13x"></i>
                <input type="text" ref="input" class="key-focus" data-model='idCode' v-model="idCode"  @focus="(e)=>e.target.select()" @keyup.enter="readCard()" />
            </div>
            <button class="btn" @click="readCard()">查询</button>
            <span class="radio-st" >
            <label class="checkbox" @click="radioClick(1)"><input type="radio" name="_fa_radio" :checked="tickChecke" />
            <i class="iconfont icon-a-danxuanweixuanzhong"></i>按券码查询</label></span>
            <!-- <span class="radio-st"  >
                <label class="checkbox" @click="radioClick(2)"><input type="radio" name="_fa_radio" :checked="mobleChecke" />
                <i class="iconfont icon-a-danxuanweixuanzhong"></i>按手机号查询</label>
            </span> -->
        </div>
        <div class="modal-body">
            <div class="clearfix">
                <div class="left-box">
                    <div class="panel">
                        <div class="panel-heading">券列表</div>
                        <div class="panel-body item-box clearfix" v-scroll-anime="{up:'left-order-up',down:'left-order-down',liClass:'.item-li',isRow:false}">
                            <div class="item-li coupons" :class="{selected:item.Check,couponsOnePay:item.Coupon_Type==5}" @click="onTicket(item)"
                                v-for="item in ticketInfos" :key="item">
                                <!-- 一键买单 -->
                                <template v-if="item.Coupon_Type==5">
                                    <div class="coupon-top">
                                        <div class="tk-tit">
                                            <div class="flex1 nowrap">{{item.Coupon_Name}}</div>
                                            <div class="money"><span class="unit">￥</span>{{item.Coupon_Amount}}</div>
                                        </div>
                                        <div class="tk-time">{{new Date(item.Start_Time).Format("yyyy-MM-dd")}}至{{new Date(item.End_Time).Format("yyyy-MM-dd")}}</div>
                                    </div>
                                    <div class="coupon-content">
                                        <div class="li-box" v-for="consumne in item.MaitonConsumeDTO?.MaitonPromotionDTOList" :key="consumne">
                                            <div class="flex1 nowrap2">•{{consumne.Coupon_Name}}<span v-if="consumne.Coupon_Number>0">({{consumne.Coupon_Number}})</span></div>
                                            <div class="money"><span class="unit">￥</span>{{consumne.OriginalPrice}}</div>
                                        </div>
                                        <div class="li-box" v-if="item.MaitonConsumeDTO?.MaitonPayPrice>0">
                                            <div class="flex1 nowrap2">•尾款</div>
                                            <div class="money"><span class="unit">￥</span>{{item.MaitonConsumeDTO?.MaitonPayPrice}}</div>
                                        </div>
                                    </div>
                                    <i class="iconfont icon-gou-fine"></i>
                                </template>
                                <div class="coupons-name" v-else>
                                    <div class="coupon-left" :class="{selected:item.Check==true}">
                                        <div class="left-txt cika" v-if="item.Coupon_Type==4">
                                            <div class="count"><span>{{item.Time_Card?.times_count-item.Time_Card?.times_used}}</span>次卡</div>
                                            <div class="used">已用{{item.Time_Card?.times_used}}次</div>
                                        </div>
                                        <div class="left-txt" v-else>
                                            <span class="m">¥</span>
                                            <span class="y">{{item.Coupon_Amount}}</span>
                                        </div>
                                    </div>
                                    <div class="coupon-right" :class="{selected:item.Check==true}">
                                        <div class="coupon-top">
                                            <div class="tk-txt nowrap">{{item.Coupon_Name}}</div>
                                            <div class="tk-time">{{item.Coupon_Code}}</div>
                                            <div class="tk-time">有效期:{{new Date(item.Start_Time).Format("yyyy-MM-dd")}}至{{new Date(item.End_Time).Format("yyyy-MM-dd")}}</div>
                                        </div>
                                        <span class="cou-ge"></span>
                                        <div class="coupon-bottom">
                                            详细信息
                                            <div class="triangle" v-show="item.extendShow==false" @click="extenClick(item)"></div>
                                            <div class="triangles" v-show="item.extendShow==true" @click="extenClick(item)"></div>
                                        </div>
                                        <div class="extend" v-show="item.extendShow==true">
                                            <span style="margin-left:-120px;" v-show="item.Consume_MinMoney>0">使用说明</span>
                                            <span class="ex-span" v-show="item.Consume_MinMoney>0" >消费满{{item.Consume_MinMoney}}元可使用此券</span>
                                        </div>
                                        <i class="iconfont icon-gou-fine"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item-operation">
                            <div class="float-right">
                                <div class="bnt-fangxiang" ref="left-order-up"><i class="iconfont icon-fangxiang-up"></i></div>
                                <div class="bnt-fangxiang" ref="left-order-down"><i class="iconfont icon-fangxiang-down"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="keyboard">
                        <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                                data-value="9">9</span></div>
                        <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                                data-value="6">6</span></div>
                        <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                                data-value="3">3</span></div>
                        <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                                data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
                    </div>
                    <div class="tr-box">
                        <el-switch v-model="Is_NotRockover" :inline-prompt="true" active-text="开启付款成功后，不直接翻台" inactive-text=""></el-switch>
                    </div>
                    <div class="box-bottom">
                        <div><span class="btm-span">待支付金额:</span>
                            <span class="btm-span-money">
                                {{invoMoney}}
                            </span>
                        </div>
                        <div class="tick-div"><span class="tick-span">券抵扣:</span><span class="tick-money">{{Number(this.tickDeduMoney).toFixed(2)}}</span></div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-border" @click="select()">重新查询核销结果</button>
            <button class="btn btn-confirm" @click="confirm()">确定</button>
        </div>
        <!--券数量修改-->
        <modal-load :isShow="numShow" :isUnload="true">
            <num-modify-model :isShow="numShow" @numCloseModel="numCloseModel" @cashConfirm="cashConfirm"></num-modify-model>
        </modal-load>
    </modal>
</template>
<script>

import { initKeyBoard } from '/src/common' 
import { newGuid } from '/src/common/index.js'
import numModifyModel from '../numModifyModel/numModifyModel.vue'

/**现金券 或 商品券 选择 */
export default {
    name:"zpCouponspayModel",
    components:{
        numModifyModel
    },
    props:{
        isShow:Boolean,
        orderInfo:Object,
        unionEatAutoID:Object,
        choicePayType:Object,
        unionType:Boolean
    },
    data(){
        return {
            //是否 付款成功后，不直接翻台
            Is_NotRockover:this.$cacheData.get("zpCouponspay_Is_NotRockover")===true,
            numShow:false,
            idCode:'',
            /**券数据 */
            ticketInfos:[],
            /**选中的券 */
            selectCoupon:[],
            /**当前选中的券 */
            presentCoupon:'',
            /**菜品信息 */
            posFoodData:'',
            tickChecke:true,
            //mobleChecke:false,
            /**保存订单支付返回记录 */
            payPreviewData:'',
            /**交易记录 */
            Payments:[],
            /**临时订单数据 */
            memberorderInfo:'',  
            unPaidMoney:0,//待付金额
            tickDeduMoney:0,//券抵扣金额
            amountMoney:0, //代金券抵扣金额
            userInfo:'', //登录用户
        }
    },
    mounted(){
        //菜品数据结构
        this.$cacheData.PosFoods().then((d)=>{
            this.posFoodData = d.data
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
        })
        this.$nextTick(()=> {
           initKeyBoard.call(this,this.$refs.code);
        })
        this.init();
    }, 
    computed:{
        //结账金额
        invoMoney(){
            let invoMoney=0;
            if(Number(this.unPaidMoney).toFixed(2) - Number(this.tickDeduMoney).toFixed(2)>0){
                invoMoney = Number(Number(this.unPaidMoney) - Number(this.tickDeduMoney)).toFixed(2)
            }
            return invoMoney
        }
    },
    watch: {
        orderInfo:{
            immediate:true,
            handler(vla){
                this.init();
            }
        },
        isShow(newVal) {
            if(newVal){
                this.init();
            }
        },
        //是否 付款成功后，不直接翻台
        Is_NotRockover(newVal){
            this.$cacheData.set("zpCouponspay_Is_NotRockover",newVal);
        },
    },
    methods:{
        /**安卓 扫码 */
		scanCode() {
			if (window.webview) {
				this.$webBrowser.hasCamera().then((isQr) => {
					if (isQr == "1") {
						this.$webBrowser.qr().then((d) => {
							this.idCode=d;
                            this.readCard();
						}).catch((e) => {
							this.$message({ message: "扫码失败:" + e, type: "warning" });
						});
					} 
				});
			} 
		},
        init(){
            //this.mobleChecke=false
            this.idCode=''
            this.ticketInfos=[],this.Payments=[],this.payPreviewData=''
            this.selectCoupon=[],this.tickChecke=true,this.tickDeduMoney=0
            this.memberorderInfo = JSON.parse(JSON.stringify(this.orderInfo))
            //合并联台的订单信息
            // if(this.unionType==true){
            //     this.memberorderInfo.UnionOrderInfoList.map(union=>{
            //         union.Order_ConsumeList.map(unOrder=>{
            //             this.memberorderInfo.Order_ConsumeList.push(unOrder)
            //         })
            //     })
            // }
            // if(this.memberorderInfo.Order_ConsumeList){
            //     this.memberorderInfo.Order_ConsumeList.map((order)=>{
            //         order = Object.assign(order,{isCoupon:false,CouponNumber:0})
            //     })
            // }
            this.unPaidMoney = this.memberorderInfo.UnPaid_Money
            this.userInfo=this.$auth.getUserInfo()
            setTimeout(() => {
                this.$refs.input.focus();
            },100);

        },
        //重新查询核销结果
        select(){
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let param={
                User_ID:this.userInfo?.User_ID,  //用户id
                Eat_AutoID:this.memberorderInfo.Eat_AutoID, //结账单ID
                Operator_Name:this.userInfo?.Login_Name, //操作员
                Operate_EquipmentID:this.userInfo?.Default_ChannelID, //设备id
                Pos_StationName:this.userInfo?.Site_Name, //站点名称
                Timestamps:this.memberorderInfo.Timestamps.toString(), //账单时间戳
            }
            const loading = this.$loading({
                text: "查询支付结果中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            this.$httpAES.post("Bestech.CloudPos.RequeryThePaymentResult",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                    if(data.ResponseBody?.Timestamps){
                        this.memberorderInfo.Timestamps = data.ResponseBody.Timestamps.toString();
                    }
                    //订单时间戳已变更需要去刷新订单时间
                    if(data.ResponseHeader.ResultCode==3002){
                        this.$emit("refreshOrder")
                    }
                }else{
                    if(data.ResponseHeader.ResultDesc){
                        this.$message.success({ message:data.ResponseHeader.ResultDesc});
                    }
                    this.memberorderInfo.Timestamps = data.ResponseBody.Timestamps.toString();
                    return;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        radioClick(type){
            if(type==1){
                this.tickChecke=true
                //this.mobleChecke=false
            }else{
                this.tickChecke=false
                //this.mobleChecke=true
            }
            setTimeout(() => {
                this.$refs.input.focus();
            },100);
        },
        extenClick(item){
            if(item.extendShow==true){
                item.extendShow=false
            }else{
                item.extendShow=true
            }
        },
        readCard(){
            if(!this.idCode){
                this.$message.warning('查询码不能为空');
                return
            }
            //获取平台券信息
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID,
                Platform_Type:5, //平台类型 1:抖音 2:美团 3:口碑 4: 翼码 5：正品卡券
                Dynamic_Code:this.idCode,
                Dynamic_Type:'',//查询码类型 ，mobile : 按手机号查询 ，不传按默认查询类型
            }
            const loading = this.$loading({
                text: "获取券信息中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CouponPlatform.GetCouponInfo",param).then((data)=>{
                loading.close();
                this.$refs.input?.focus();
                this.$refs.input?.select();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc)
                }else{
                    console.log(data?.ResponseBody)
                    this.ticketInfos = data?.ResponseBody;
                    this.ticketInfos.forEach(tick=>{
                        Object.assign(tick,{
                            extendShow:false,
                            Check:false,
                            deDuMoney:0,
                            newCoupon_Id:newGuid()
                        })
                    })
                    this.memberorderInfo = JSON.parse(JSON.stringify(this.orderInfo))
                    //合并联台的订单信息
                    if(this.unionType==true){
                        this.memberorderInfo?.UnionOrderInfoList.map(union=>{
                            union.Order_ConsumeList.map(unOrder=>{
                                this.memberorderInfo.Order_ConsumeList.push(unOrder)
                            })
                        })
                    }
                    if(this.memberorderInfo.Order_ConsumeList){
                        this.memberorderInfo.Order_ConsumeList.forEach((order)=>{
                            Object.assign(order,{isCoupon:false,CouponNumber:0})
                        })
                    }
                    this.memberorderInfo.Order_ConsumeList.sort(this.compare('Eat_CheckPrice',''));
                    this.unPaidMoney = this.memberorderInfo.UnPaid_Money
                    this.selectCoupon=[],this.tickDeduMoney=0
                    return
                    
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        //关闭
        hide(){
            this.$emit("closeModel")
        },
        //点击券
        onTicket(item){
            if(item.Check==true){
                this.selectCoupon.some((set,index)=>{
                    if(set.newCoupon_Id==item.newCoupon_Id){
                        if(set?.Check==true){
                            if(item.Coupon_Type==4){//次卡
                                this.tickDeduMoney -= Number(set.deDuMoney);
                                item.CouponNum=0;
                            }else{
                                if(set.Exchange_Num){
                                    this.tickDeduMoney -= Number(set.deDuMoney) * Number(set.Exchange_Num);
                                }else{
                                    this.tickDeduMoney -= Number(set.deDuMoney);
                                }
                                if(set?.CouponNum){
                                    this.tickDeduMoney -= Number(set.deDuMoney) * (Number(set.CouponNum)-1);
                                }
                                //券类型 1:代金券 2:折扣券 3.商品券
                                if(item.Coupon_Type==3){
                                    this.memberorderInfo.Order_ConsumeList.forEach(order=>{
                                        if(set.ConsumeID==order.Eat_ConsumeID){
                                            order.CouponNumber = Number(Number(Number(order.CouponNumber)-1).toFixed(2));
                                            order.isCoupon=false;
                                        }
                                    })
                                }
                            }
                            this.selectCoupon.splice(index,1);
                            item.Check=false;
                        }
                        return true
                    }
                })
            }else{
                //券的最低消费额，0 不限制
                if(item.Consume_MinMoney!=0){
                    //this.orderInfo.Eat_CheckMoney
                    if(this.orderInfo.Payable_Money<item.Consume_MinMoney){
                        this.$message.warning('账单未达到使用该券的金额!');
                        return
                    }
                }
                //时间段控制 0所有时段,1指定时段
                let date = new Date((new Date()).Format("yyyy-MM-dd 00:00:00")); //当前时间 只用年月日判断
                let Start_Time=new Date((new Date(item.Start_Time)).Format("yyyy-MM-dd 00:00:00"));
                let End_Time=new Date((new Date(item.End_Time)).Format("yyyy-MM-dd 00:00:00"));
                if(Start_Time>date || date >End_Time){
                    this.$message.warning('不在该券可使用的时间范围内!');
                    return
                }
                //1.代金券
                if(item.Coupon_Type==1){
                    item.Check=true;
                    item.deDuMoney = item.Coupon_Amount
                    this.CoupondeduMoney(item,'','')
                }else if(item.Coupon_Type==2){//2.折扣价
                    item.Check=true
                    item.deDuMoney = Number(Number(this.unPaidMoney)-(Number(this.unPaidMoney) * (item.Discount_Rate / 100)).toFixed(2))
                    this.CoupondeduMoney(item,'','')
                }else if(item.Coupon_Type==3){//3.商品券
                    //FoodRange_Type适用类型 1:通用券，所有商品适用，2:部分商品券
                    if(item.FoodRange_Type==1){
                        let _type=0
                        this.memberorderInfo.Order_ConsumeList.some(order=>{
                            if(order.isCoupon==false && order.Food_Type!=4 && order.Eat_Number>0 && order.Is_Gift==false && order.Eat_Number>order.Exchanged_Number){
                                if(item.Food_Weight==0){
                                    item.deDuMoney = Number(order.Eat_CheckPrice)
                                    item.Check=true
                                    this.CoupondeduMoney(item,order,'')
                                    if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                        order.CouponNumber += 1
                                    }
                                    if(order.CouponNumber>=order.Eat_Number){
                                        order.isCoupon=true
                                    }
                                    _type=1
                                    return true
                                }else{
                                    let _weight=this.commWeight(item,order)
                                    item.deDuMoney = Number(order.Eat_CheckPrice)
                                    item.Check=true
                                    this.CoupondeduMoney(item,order,_weight)
                                    if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                        order.CouponNumber += _weight
                                    }
                                    if(order.CouponNumber>=order.Eat_Number){
                                        order.isCoupon=true
                                    }
                                    _type=1
                                    return true
                                }
                            }
                        })
                        if(_type==0){
                            this.$message.warning('没有满足条件的菜品,请检查当前下单的菜品或者退出重新进入订单后,再次尝试!');
                            return
                        }
                    }else if(item.FoodRange_Type==2){
                        let title =''
                        let _types = 0;
                        if(item.Exchange_FoodCodes && item.Exchange_FoodCodes.length>0){
                            this.memberorderInfo.Order_ConsumeList.some(order=>{
                                if(order.isCoupon==false && order.Food_Type!=4){
                                    if(item.Exchange_FoodCodes.indexOf(order.EAT_XFCode)!=-1 && order.Eat_Number>0 && order.Is_Gift==false && order.Eat_Number>order.Exchanged_Number){
                                        if(item.Food_Weight==0){
                                            _types=1
                                            item.deDuMoney = Number(order.Eat_CheckPrice)
                                            item.Check=true
                                            if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                                order.CouponNumber += 1
                                            }
                                            if(order.CouponNumber>=order.Eat_Number){
                                                order.isCoupon=true
                                            }
                                            this.CoupondeduMoney(item,order,'')
                                        }else{
                                            _types=1
                                            let _weight=this.commWeight(item,order)
                                            item.deDuMoney = Number(order.Eat_CheckPrice)
                                            item.Check=true
                                            if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                                order.CouponNumber += _weight
                                            }
                                            if(order.CouponNumber>=order.Eat_Number){
                                                order.isCoupon=true
                                            }
                                            this.CoupondeduMoney(item,order,_weight)
                                        }
                                        
                                    }else{
                                        if(order.Eat_Number<=order.Exchanged_Number){
                                            title = '该券对应的菜品已使用过券,已不满足条件'
                                        }else{
                                            title = '未找到编号'+item.Exchange_FoodCodes+'的菜品,券id【'+item.Coupon_TemplateId+'】,请检查当前下单的菜品或者退出重新进入订单后,再次尝试!'
                                        }
                                    }
                                    if(_types==1){
                                        return true
                                    }
                                }
                            })
                        }else{
                            title="商品券没有关联商品,券id【"+item.Coupon_TemplateId+"】";
                        }
                        if(_types==0){
                            if(title==''){
                                title='没有满足条件的菜品,请检查当前下单的菜品或者退出重新进入订单后,再次尝试!'
                            }
                            this.$alert(title,"提示");
                            return
                        }
                    }
                }else if(item.Coupon_Type==4){//次卡
                    let count=item.Time_Card.times_count-item.Time_Card.times_used;//剩余次数
                    if(count==1){
                        item.Check=true;
                        let money=item.Time_Card.serial_amount_list[item.Time_Card.times_used].amount.list_market_amount;
                        item.deDuMoney = money/100;
                        this.CoupondeduMoney(item,'','');
                    }else if(count>1){//弹出数量选择 
                        this.numShow=true;
                        this.presentCoupon=item;
                    }else{
                        this.$message.warning('剩余次数为0,无法继续核销!');
                    }
                    return;
                }else if(item.Coupon_Type==5){//一键买单
                    item.Check=true;
                    item.deDuMoney = item.Coupon_Amount
                    this.CoupondeduMoney(item,'','')
                }
                //如果IsVerifyWithInputNum为True则弹出数量选择 
                if(item.IsVerifyWithInputNum || item.Coupon_Type==4){
                    this.numShow=true
                    this.presentCoupon=item
                }
            }
        },
        //商品券兑换商品重量(单位：斤），0 不限制
        commWeight(item,order){
            if(item.Food_Weight>=order.Eat_Number){
                return order.Eat_Number
            }else if(item.Food_Weight<=order.Eat_Number-order.Exchanged_Number){
                return item.Food_Weight
            }else if(item.Food_Weight>order.Eat_Number-order.Exchanged_Number){
                return Number(Number(order.Eat_Number-order.Exchanged_Number).toFixed(2))
            }
        },
        //deduMoney变动
        CoupondeduMoney(item,order,weight){
            let _item= JSON.parse(JSON.stringify(item))
            this.selectCoupon.push(_item)
            this.tickDeduMoney=0
            this.selectCoupon.forEach(sele=>{  
                if(sele.Check==true && !sele?.ConsumeID && sele.Coupon_Type!=4){
                    if(order){
                        if(sele.Food_Weight!=0){
                            Object.assign(sele,{ConsumeID:order.Eat_ConsumeID,Exchange_Num:weight})
                        }else{
                            let _num=0
                            if(order.Exchanged_Number!=0){
                                if(order.Eat_Number-order.Exchanged_Number>1){
                                    _num=1
                                }else{
                                    _num = order.Eat_Number-order.Exchanged_Number
                                }
                            }else{
                                if(order.Eat_Number<1){
                                    _num = order.Eat_Number
                                }else{
                                    _num = 1
                                }
                            }
                            sele = Object.assign(sele,{ConsumeID:order.Eat_ConsumeID,Exchange_Num:_num})
                        }
                    }else{
                        sele.Exchange_Num=1;
                    }
                }
                if(sele.Exchange_Num){
                    this.tickDeduMoney += sele.deDuMoney * sele.Exchange_Num
                }else{
                    this.tickDeduMoney += sele.deDuMoney
                }
            })
        },
        //确定支付
        confirm(){
            if(this.selectCoupon.length==0){
                this.$message.warning('请先选择优惠券!');
                return
            }
            /**支付方式 */
            let _unpaiMoney = Number(this.unPaidMoney)
            let _payment=[]
            this.selectCoupon.forEach(tick=>{
                let _choice={
                    Coupon_AutoId:tick.Coupon_TemplateId,
                    Coupon_Code:tick.Coupon_Code,
                    Coupon_Name:tick.Coupon_Name,
                    Coupon_Kind:tick.Coupon_Type,
                    Coupon_Num:1,
                    Coupon_CostPrice:tick.Merchant_FactAmount,
                    Exchange_ConsumeID:tick?.ConsumeID,
                    Exchange_Num:tick?.Exchange_Num,
                    Coupon_VerifyToken:tick.Coupon_VerifyToken,
                    Scene_Type:1,
                    External_UserId:tick?.External_UserId,
                    Customer_Mobile:tick?.Customer_Mobile,
                    Channel_ID:tick?.Channel_ID
                }
                if(tick?.CouponNum){
                    _choice.Coupon_Num=Number(tick?.CouponNum)
                }
                if(tick.Coupon_Type==5){//一键买单 券接口返回该节点，核销支付时也要传入
                    _choice.MaitonConsumeDTO=tick.MaitonConsumeDTO;
                }
                //多收金额
                let OverChargeMoney=0
                if(Number(tick.deDuMoney) * 1 >= _unpaiMoney){
                     OverChargeMoney = Number(tick.deDuMoney) * 1 - _unpaiMoney
                     _unpaiMoney=0
                }else{
                    _unpaiMoney = _unpaiMoney - Number(tick.deDuMoney) * 1
                }
                let Payment_Money=Number(tick.deDuMoney) * tick.Exchange_Num; //商品券 支付金额
                if(tick.Coupon_Type==1){//代金券 支付金额
                    Payment_Money=Number(tick.deDuMoney) * _choice.Coupon_Num;
                }else if(tick.Coupon_Type==2){//折扣券 支付金额
                    Payment_Money=Number(tick.deDuMoney);
                }else if(tick.Coupon_Type==4){//次卡
                    Payment_Money=Number(tick.deDuMoney);
                    _choice.Time_Card=tick.Time_Card;
                    _choice.Platform_OrderId=tick.Platform_OrderId;//平台订单ID
                }
                _payment.push({
                    Payment_ID:this.choicePayType.PAY_ID,  //支付方式ID
                    Payment_Code:this.choicePayType.PAY_CODE, //支付方式编号
                    Payment_Name:this.choicePayType.PAY_NAME, //支付方式名称
                    Payment_Type:this.choicePayType.INTERFACE_TYPE, //支付方式类型
                    Payment_Money: Payment_Money, //支付金额
                    OverCharge_Money:OverChargeMoney,  //多收金额
                    Payment_FactMoney:0, //计营业额
                    Qr_Code:'', //扫码付款的码值
                    Card_No:'', //卡号
                    CouponInfo:_choice, //券的详情
                })
            })
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID, //登陆用户ID
                Eat_AutoID: this.memberorderInfo.Eat_AutoID,//结账单ID
                UnionOrders:this.unionEatAutoID,//联台订单ID集合
                Timestamps:this.memberorderInfo.Timestamps.toString(), //账单时间戳
                Operator_Name:this.userInfo?.Login_Name,//操作员
                Eat_DeskName:this.memberorderInfo.Eat_DeskName, //桌牌号
                Service_Charge:this.memberorderInfo.Service_Money,  //服务费
                MantissaAdjustment_Money:this.memberorderInfo.Mantissa_Money,  //尾数调整金额
                Member:'',//会员信息
                Payments:_payment, //支付方式列表
                Is_NotRockover:this.Is_NotRockover//付款成功后，不直接翻台
            }
            this.$emit("publicPayPreview",param,'zpCouponShow',this.selectCoupon)
        },
        //券数量确认
        cashConfirm(allNum){
            if(this.presentCoupon.Coupon_Type==4){//次卡
                let times_used=this.presentCoupon.Time_Card.times_used;
                let amountList=this.presentCoupon.Time_Card.serial_amount_list;
                if(times_used+allNum>amountList.length){
                    this.$message.warning('核销数量不能超过剩余次数!');
                    return;
                }
                
                let money=0;
                amountList.slice(times_used,times_used+allNum).forEach(it=>{
                    money+=it.amount.list_market_amount/100;
                })

                this.presentCoupon.Check=true;
                this.numShow=false;
                this.presentCoupon.deDuMoney = money;
                this.presentCoupon.CouponNum = allNum;
                this.CoupondeduMoney(this.presentCoupon,'','');
            }else{
                this.numShow=false;
                this.selectCoupon.forEach(tick=>{
                    if(tick.newCoupon_Id==this.presentCoupon.newCoupon_Id){
                        if(!tick?.CouponNum){
                            tick = Object.assign(tick,{CouponNum:allNum})
                        }else{
                            tick.CouponNum=allNum
                        }
                        this.tickDeduMoney += tick.deDuMoney *(Number(tick.CouponNum)-1)
                    }
                })
            }
        },
        //券数量取消
        numCloseModel(){
            this.numShow=false;
            if(this.presentCoupon.Coupon_Type!=4){
                this.onTicket(this.presentCoupon)
            }
            
            this.presentCoupon=''
        },
        /**数组排序 */
        compare(attr,Time) {
            return function(a,b){
                var val1 = a[attr];
                var val2 = b[attr];
                var Times1 = a[Time];
                var Times2 = b[Time];
                return val2 - val1 || Times1 - Times2;
            }
        }
    }
}
</script>

<style lang="sass">
@import "./zpCouponspayModel.scss";
</style>